import React, { useContext, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import uuid from 'react-uuid';
import { FIRM_INFO, LOG_IN, LOG_OUT, MEASUREMENT_DATE, USER_VALIDATION } from 'common/constants/process-management';
import { useStore } from 'common/store';
import { SecurePortalParams } from 'common/types/reactRouter';
import { UseStoreValues } from 'common/types/store';
import { TaskContext } from 'context/TaskContext';
import { TaskContextType } from 'context/TaskContext/types';
import ProcessManagementDocumentUploads from './ProcessManagementDocumentUploads/ProcessManagementDocumentUploads';

const ProcessManagementDocumentsUpload = () => {
  const { task, setHeaderMenuItems, questionnaireUrl, documentUrl, requestedFiles } = useContext(
    TaskContext
  ) as TaskContextType;
  const { requestId, hmacToken, processType } = useParams<SecurePortalParams>();
  const [{ user }] = useStore() as unknown as UseStoreValues;
  const pairedQuestionnaire = task.paired_questionnaire;
  const rightHeaderItems = useMemo(() => {
    if (!pairedQuestionnaire) {
      return [];
    }
    return [
      {
        id: uuid(),
        component: MEASUREMENT_DATE,
        label: '',
        link: '',
        withArrow: false,
        hideOnMobile: false,
      },
      {
        id: uuid(),
        label: user ? LOG_OUT : LOG_IN,
        link: `/${processType}/requests/${requestId}/${hmacToken}`,
        component: USER_VALIDATION,
        withArrow: false,
        hideOnMobile: false,
      },
    ];
  }, [hmacToken, pairedQuestionnaire, processType, requestId, user]);

  useEffect(() => {
    setHeaderMenuItems({
      left: [
        {
          id: uuid(),
          component: FIRM_INFO,
          label: '',
          link: '',
          withArrow: false,
          hideOnMobile: false,
        },
      ],
      right: rightHeaderItems,
    });
  }, [
    documentUrl,
    hmacToken,
    processType,
    questionnaireUrl,
    requestId,
    setHeaderMenuItems,
    user,
    pairedQuestionnaire,
    rightHeaderItems,
  ]);

  return <>{requestedFiles && <ProcessManagementDocumentUploads pairedQuestionnaire={pairedQuestionnaire} />}</>;
};

export default ProcessManagementDocumentsUpload;
